export default class AdsGroup {
  constructor() {
    // config
    this.key = 'ads'
    this.name = 'Advertising'
    this.description = ''
  }
}
